<div id="tableContainer-1">
  <form [formGroup]="selectFormInvoice">
    <table>
      <tr>
        <th>Enter Optional Search Criteria</th>
      </tr>
      <div *ngIf="bulkSelect && parentCustomerNumbers">
        <br>
        <strong>You are bulk searching invoices by the following parent numbers:</strong>
        <span *ngFor="let p of parentCustomerNumbers; let isLast=last">
          {{p}}{{isLast ? '' : ', '}}
        </span>
      </div>
      <div>
        <table id="tableContainer-2">
          <div class="requesttype-radio-group">
            <tr *ngIf="!bulkSelect">
              <td>
                <input type="radio" formControlName="requestType" [value]="'I'"/>
                Search by Invoice Number Range
              </td>
            </tr>

            <tr *ngIf="!bulkSelect">
              <td>
                <input type="radio" formControlName="requestType" [value]="'O'"/>
                Search by Order Number Range
              </td>
            </tr>

            <!-- Always render the Date Range option -->
            <tr>
              <td>
                <input type="radio" formControlName="requestType" [value]="'D'"/>
                Date Range
              </td>
            </tr>
          </div>

          <!-- IF DATERANGECHK-->
          <tr #dateRange *ngIf="dateRangeChk; else textRange">
            <!-- THIS ONE -->
            <br>
            <div *ngIf="dateRangeChk" class="datetype-radio-group" style="display: flex; flex-direction: column; gap: 8px;">
              <label *ngFor="let daterequesttype of daterequesttypes" style="display: flex; align-items: center; gap: 4px;">
                <input type="radio" formControlName="invoiceType" [value]="daterequesttype.id">
                {{ daterequesttype.text }}
              </label>
            </div>
            
            <!-- THIS ONE TOO -->
            <div style="display: flex; flex-direction: column; gap: 8px; margin-top: 16px;">
              <label>
                From:
                <kendo-datepicker formControlName="selectedStartDateInvoice"
                                  placeholder="Start Date"
                                  [format]="'yyyy-MM-dd'"
                                  [min]="minEndDate"
                                  [max]="maxEndDate">
                </kendo-datepicker>
              </label>
            
              <label>
                To:
                <kendo-datepicker formControlName="selectedEndDateInvoice"
                                  placeholder="End Date"
                                  [format]="'yyyy-MM-dd'"
                                  [min]="minEndDate"
                                  [max]="maxEndDate">
                </kendo-datepicker>
              </label>
            
              <div *ngIf="nextDisabled" kendoTooltip style="text-align: center;">
                <kendo-formerror style="padding-top: 8px; border-bottom: 1px dotted red;"
                                 [title]="'End date must be before ' + (maxEndDate | date) + '.'">
                  Invalid end date for invoice selection.
                </kendo-formerror>
              </div>
            </div>
          </tr>
          <!-- ELSE -->
          <ng-template #textRange>
            <tr>
              <td><br> From:
                <input kendoTextBox 
                        type="text" 
                        placeholder="From"
                        formControlName="fromRange"
                        #fromRange>
                To:
                <input kendoTextBox 
                        type="text" 
                        placeholder="To"
                        formControlName="toRange"
                        #toRange>
              </td>
            </tr>
          </ng-template>
        </table>
      </div>

      <tr>
        <td>
          <input type="checkbox" formControlName="downloaded">
          Include only invoices not previously downloaded
        </td>
      </tr>

      <br>

      <tr>
        <td>
          <table>
            <tr>
              <td>
                <app-mcl-button text="< Back To Store Selection" primary="true" (click)="backClicked()">
                </app-mcl-button>
              </td>
              <td>
                <app-mcl-button text="Next To Invoice Selection >" primary="true" (click)="nextClicked()"
                            [disabled]="nextDisabled">
                </app-mcl-button>
              </td>
              <td>
                <app-mcl-button text="Cancel" primary="true" (click)="cancelClicked()">
                </app-mcl-button>
              </td>
            </tr>
            <tr *ngIf="nextDisabled">
              <td>
                
              </td>
            </tr>
            <tr *ngIf="isViewOnly">
              <td>
                <div kendoTooltip style="text-align: center; margin: 4px;">
                  <strong style="padding-top: 8px; border-bottom: 1px dotted black;" title="The date range is outside the range allowed for invoice downloads.">View only mode <kendo-svg-icon [icon]="viewOnly"></kendo-svg-icon></strong>
                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </form>
</div>
<div kendoDialogContainer></div>
